export default {
  'roleDetail.title': '角色详情',
  'roleEdit.createRole.title': '新建角色',
  'roleEdit.editRole.title': '编辑角色',
  'roleEdit.saveRole': '保存角色',
  'roleEdit.section.generalInformation': '基本信息',
  'roleEdit.section.accessPermissions': '访问权限',
  'roleEdit.section.datePermissions': '数据权限',
  'roleEdit.section.members': '员工',
  'roleEdit.field.name': '角色名(英文)',
  'roleEdit.field.foreign_name': '角色名(中文)',
  'roleEdit.field.permission': '角色权限',
  'roleEdit.field.dataPermission': '数据权限',
  'roleEdit.field.is_system': '是否系统角色',
  'roleEdit.field.enforeClockInBeforeAccess': '必须打上班卡才能使用POS App',
  'roleEdit.field.enforeCloseAllOrdersClockOut': '打下班卡前必须关闭所有的订单',
  'roleEdit.field.enableRoleRetainCash': '计算“餐厅现金总计”',
  'roleEdit.field.deductCreditCardTips': '刷卡小费扣留',
  'roleEdit.field.deductNetSales': '堂食净销售额扣留',
  'roleEdit.field.enableRoleRetainCash.description': `打开后，日结单上的“餐厅现金总计”将为您计算属于餐厅的现金总额，以方便您跟员工结算现金;`,
  'roleEdit.field.enableRoleRetainCash.isDriver.description': `打开后，司机日结单上的“餐厅现金总计”将为您计算属于餐厅的现金总额，以方便您跟司机结算现金;`,
  'roleEdit.houseCash.base': '餐厅现金总计（应付餐厅现金）= 持有现金总计 - 服务小费',
  'roleEdit.houseCash.withholdCardTips': '刷卡小费扣留',
  'roleEdit.houseCash.withholdDineInNetSales': '堂食净销售额扣留',
  'roleEdit.houseCash.isDriver.base': '餐厅现金总计（应付餐厅现金）= 持有现金总计',
  'roleEdit.houseCash.isDriver.deliceryTips': '递送小费',
  'roleEdit.houseCash.isDriver.deliceryTipsAnddeliceryFee': '（递送小费 + 递送费）',
  'roleEdit.cardTips': '刷卡小费',
  'roleEdit.netSales': '堂食净销售额',
  'roleEdit.deliveryTipsAreDefaultedToDrivers': '餐厅现金总计的计算，减去递送费。',
  'roleEdit.name.errors.empty': '请输入角色中文名',
  'roleEdit.foreign_name.errors.empty': '请输入角色英文名',
  'roleEdit.permission.errors.empty': '请选择权限',
  'roleEdit.is_system.errors.empty': '请设置是否是系统角色',
  'roleEdit.create_success': '创建角色成功',
  'roleEdit.update_success': '更新角色成功',
  'roleEdit.table_service.restrict': '(此权限类别仅在餐厅提供“堂食服务”时可使用)',
  'roleEdit.search.placeholder': '根据姓名/手机号筛选',
  'roleEdit.allOrders.desc': '未授予此权限的用户只能查看过去24小时内自己创建的已完成订单和授权单。',
  'roleEdit.manuallyEnterWeight.desc': '授予此权限的用户可以在连接电子秤的情况下手动输入重量。',
  'roleEdit.driver': '全职司机（只配送，不接单）',
  'roleEdit.house_cash.including_delivery': `"餐厅现金总计"的计算，包含由该员工创建的递送订单。`,
  'roleEdit.house_cash.tips_include_delivery_tips': `打开后，"持有现金总计"包含递送订单，归属于员工的小费也包含递送小费。`,
  'roleEdit.house_cash.calculation_delivery_fee': `餐厅现金总计的计算，减去递送费。`,
  'roleEdit.houseCash.delicery_tips': '递送小费',
  'roleEdit.houseCash.delicery_fee': '递送费',

  'roleEdit.tipOut.title': '设置小费分出',
  'roleEdit.tipOut.title.desc': '打开开关，在日结单里增加 "员工小费账户"来帮您计算小费分出后员工应得的小费。',
  'roleEdit.tipOut.tipOut': '小费分出',
  'roleEdit.tipOut.netSales.desc': '净销售额（店内销售）',
  'roleEdit.tipOut.netSales.tips':
    '店内销售：包含所有非线上渠道的订单，如，到店点餐、电话订单、扫码点餐、自助点餐机。服务类型包含了对应渠道的堂食、外带和递送订单。',
  'roleEdit.tipOut.dineIn.desc': '净销售额（堂食）',
  'roleEdit.tipOut.serviceTips.desc': '服务小费',
  'roleEdit.tipOut.rule': '小费分出不能为空或0',
  'roleEdit.tipOut.sections.rule': '至少一个小费分出不为空或0',
  'roleEdit.tipOut.netSalesOfSections.desc': '区域净销售额',
  'roleEdit.tipOut.tipsSection.desc': '区域小费',
  'roleEdit.tipOut.netSalesOfSections.noSections': '您还未设置区域',
  'roleEdit.tipOut.netSalesOfSections.netSales': '净销售额',
  'roleEdit.tipOut.tipsOfSection.netSales': '区域小费',
  'roleEdit.tipOut.wain': '餐厅现金总计和小费分出，暂时不通同时打开',
  'roleEdit.houseCash.withholding': '扣留限制在部分菜品上。',
  'roleEdit.houseCash.add_restricted': '添加限制的菜品',
  'roleEdit.houseCash.add_restricted.title': '菜品',

  'roleEdit.houseCash.add_restricted.table_title_items': '限制菜品',
  'roleEdit.houseCash.add_restricted.table_title_quantity': '数量',
  'roleEdit.houseCash.add_restricted.table_title_action': '操作',
};
